import React, {useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';
import feather from 'feather-icons';

const navLinks = [
  { to: '/home', label: 'Home' },
  { to: '/projects', label: 'Projects' },
  { to: '/blog', label: 'Blog' },
];

function Header() {

  const [open,setOpen] = useState(false);

  useEffect(() => {
    feather.replace();
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <nav className="bg-slate-900 text-slate-400 font-sans">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 border-slate-700 border-b">
        <span className="flex items-center gap-4">
          <a href="https://github.com/AnandKri" target="_blank" rel="noopener noreferrer" className='hover:text-teal-300 text-slate-400 hover:-translate-y-1 transition-all duration-200'>
            <i data-feather="github"></i>
          </a>
          <a href="https://www.linkedin.com/in/anand-krishna99/" target='_blank' rel="noopener noreferrer" className='hover:text-teal-300 text-slate-400 hover:-translate-y-1 transition-all duration-200'>
            <i data-feather="linkedin"></i>
          </a>
          <a href="https://www.instagram.com/frame.of.moment" target='_blank' rel="noopener noreferrer" className='hover:text-teal-300 text-slate-400 hover:-translate-y-1 transition-all duration-200'>
            <i data-feather="instagram"></i>
          </a>
          <a href="mailto:anand.krishna0802@gmail.com" target='_blank' rel="noopener noreferrer" className='hover:text-teal-300 text-slate-400 hover:-translate-y-1 transition-all duration-200'>
            <i data-feather="mail"></i>
          </a>
        </span>

        <button
          className='group md:hidden w-6 h-6 flex flex-col items-center justify-center gap-1.5'
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-controls="mobile-menu"
        >
          <span className={`block h-[2px] w-6 bg-slate-400 group-hover:bg-teal-300 transition-all duration-300 motion-reduce:transition-none ${open ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block h-[2px] w-6 bg-slate-400 group-hover:bg-teal-300 transition-all duration-300 motion-reduce:transition-none ${open ? 'opacity-0' : 'opacity-100'}`}></span>
          <span className={`block h-[2px] w-6 bg-slate-400 group-hover:bg-teal-300 transition-all duration-300 motion-reduce:transition-none ${open ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>

        {open && (
          <div
            className="fixed inset-0 top-16 bg-black/50 z-40 md:hidden"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          ></div>
        )}

        <ul
          id="mobile-menu"
          className={`font-medium flex flex-col md:flex-row gap-6 md:gap-8
                      fixed md:static top-16 right-0 z-50
                      max-h-[60vh] w-auto
                      bg-slate-900 md:bg-transparent p-6 md:p-0 shadow-lg md:shadow-none
                      border-l border-slate-700 md:border-l-0
                      overflow-y-auto
                      transition-transform duration-300
                      ${open ? "translate-x-0" : "translate-x-full md:translate-x-0"}
                    `}
        >
          {navLinks.map((link) => (
            <li key={link.to} className="relative group">
              <NavLink to={link.to} onClick={() => setOpen(false)} className="relative">
                {({ isActive }) => (
                  <>
                    <span className={isActive ? 'text-teal-300' : 'hover:text-teal-300'}>{link.label}</span>
                    <span className={`block h-[2px] bg-teal-300 transition-all duration-200 ease-out ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`}></span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Header;
